import { defineComponent as f, ref as s } from "vue";
import { D as m, E as c } from "./DFormField-4ieG0P0S.js";
import "./useHammerSwipe-DqcYRvhM.js";
import { u as y } from "./useModel-IfHLT9OI.js";
import "./_baseClone-CPYgn-G_.js";
import { n as _ } from "./index.browser-CWCjzKuA.js";
import { n as v } from "./_plugin-vue2_normalizer-WQT2Fc8L.js";
import './assets/DInput-DAwYGIl0.css';const b = f({
  components: {
    DFormField: m
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    clearable: Boolean,
    blocked: Boolean,
    disabled: Boolean,
    dark: Boolean,
    error: Boolean,
    size: { type: String, default: () => c.LARGE },
    loading: Boolean,
    modelValue: { type: String, default: void 0 },
    label: { type: String, default: "" },
    placeholder: { type: String, default: void 0 },
    name: { type: String, default: "" },
    type: { type: String, default: "text" },
    autocomplete: { type: String, default: void 0 },
    inputmode: { type: String, default: "text" },
    id: { type: String, default: () => _() }
  },
  emits: {
    "update:modelValue": (n) => n === void 0 || typeof n == "string"
  },
  setup(n, { emit: e }) {
    const o = s(!1), t = y(n, "modelValue", e), l = s(null);
    return {
      localValue: t,
      focused: o,
      ESize: c,
      onClear: () => {
        var r;
        t.value = void 0, (r = l.value) == null || r.focus();
      },
      input: l
    };
  }
}), V = {
  "d-input__input": "_d-input__input_18wap_7"
};
var g = function() {
  var e = this, o = e._self._c;
  return e._self._setupProxy, o("DFormField", { class: e.$style["d-input"], attrs: { id: e.id, focused: e.focused, disabled: e.disabled, error: e.error, dark: e.dark, size: e.size, blocked: e.blocked, "has-value": !!e.localValue || !!e.placeholder && e.focused, loading: e.loading, clearable: e.clearable }, on: { clear: e.onClear }, scopedSlots: e._u([{ key: "label", fn: function() {
    return [e._v(" " + e._s(e.label) + " ")];
  }, proxy: !0 }, { key: "control", fn: function({ id: t }) {
    return [e.type === "checkbox" ? o("input", { directives: [{ name: "model", rawName: "v-model", value: e.localValue, expression: "localValue" }], ref: "input", class: e.$style["d-input__input"], attrs: { id: t, disabled: e.disabled, readonly: e.blocked, placeholder: e.focused ? e.placeholder : "", name: e.name, autocomplete: e.autocomplete, inputmode: e.inputmode, type: "checkbox" }, domProps: { checked: Array.isArray(e.localValue) ? e._i(e.localValue, null) > -1 : e.localValue }, on: { focus: function(l) {
      e.focused = !0;
    }, blur: function(l) {
      e.focused = !1;
    }, change: function(l) {
      var a = e.localValue, r = l.target, p = !!r.checked;
      if (Array.isArray(a)) {
        var d = null, u = e._i(a, d);
        r.checked ? u < 0 && (e.localValue = a.concat([d])) : u > -1 && (e.localValue = a.slice(0, u).concat(a.slice(u + 1)));
      } else
        e.localValue = p;
    } } }) : e.type === "radio" ? o("input", { directives: [{ name: "model", rawName: "v-model", value: e.localValue, expression: "localValue" }], ref: "input", class: e.$style["d-input__input"], attrs: { id: t, disabled: e.disabled, readonly: e.blocked, placeholder: e.focused ? e.placeholder : "", name: e.name, autocomplete: e.autocomplete, inputmode: e.inputmode, type: "radio" }, domProps: { checked: e._q(e.localValue, null) }, on: { focus: function(l) {
      e.focused = !0;
    }, blur: function(l) {
      e.focused = !1;
    }, change: function(l) {
      e.localValue = null;
    } } }) : o("input", { directives: [{ name: "model", rawName: "v-model", value: e.localValue, expression: "localValue" }], ref: "input", class: e.$style["d-input__input"], attrs: { id: t, disabled: e.disabled, readonly: e.blocked, placeholder: e.focused ? e.placeholder : "", name: e.name, autocomplete: e.autocomplete, inputmode: e.inputmode, type: e.type }, domProps: { value: e.localValue }, on: { focus: function(l) {
      e.focused = !0;
    }, blur: function(l) {
      e.focused = !1;
    }, input: function(l) {
      l.target.composing || (e.localValue = l.target.value);
    } } })];
  } }, e.$slots.innerPrepend ? { key: "innerPrepend", fn: function() {
    return [e._t("innerPrepend")];
  }, proxy: !0 } : null, e.$slots.innerAppend ? { key: "innerAppend", fn: function() {
    return [e._t("innerAppend")];
  }, proxy: !0 } : null, e.$slots.messages ? { key: "messages", fn: function() {
    return [e._t("messages")];
  }, proxy: !0 } : null, e.$slots.prepend ? { key: "prepend", fn: function() {
    return [e._t("prepend")];
  }, proxy: !0 } : null, e.$slots.append ? { key: "append", fn: function() {
    return [e._t("append")];
  }, proxy: !0 } : null], null, !0) });
}, k = [];
const i = {
  $style: V
};
function h(n) {
  for (var e in i)
    this[e] = i[e];
}
var x = /* @__PURE__ */ v(
  b,
  g,
  k,
  !1,
  h
);
const D = x.exports;
export {
  D
};
